import { memoize as lodashMemoize } from 'lodash';

export default fn => lodashMemoize(fn, (...args) => JSON.stringify(args));
